import React from 'react'

const TransaksiUspPotongan = () => {
  return (
    <div>Transaksisimangpotongan</div>
  )
}

export default TransaksiUspPotongan